import { ChatWidgetConfig, WidgetTheme } from '../types'

export const DEFAULT_CONFIG: Required<ChatWidgetConfig> = {
  apiKey: '',
  apiUrl: 'http://localhost:3000/api',
  position: 'bottom-right',
  themeColor: '#3B82F6',
  welcomeMessage: 'Hello! How can I help you today?',
  placeholder: 'Type your message...',
  height: '510px',
  width: '350px',
  autoOpen: false,
  showCloseButton: true,
  enableSounds: false,
}

export const DEFAULT_THEME: WidgetTheme = {
  primaryColor: '#3B82F6',
  backgroundColor: '#ffffff',
  textColor: '#374151',
  borderRadius: '12px',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
}

export class ConfigManager {
  private config: Required<ChatWidgetConfig>

  constructor(userConfig: ChatWidgetConfig) {
    this.config = { ...DEFAULT_CONFIG, ...userConfig }
    this.validateConfig()
  }

  private validateConfig(): void {
    if (!this.config.apiKey) {
      throw new Error('API key is required')
    }

    if (!this.config.apiKey.startsWith('tc_')) {
      console.warn('API key should start with "tc_" prefix')
    }
  }

  getConfig(): Required<ChatWidgetConfig> {
    return this.config
  }

  updateConfig(updates: Partial<ChatWidgetConfig>): void {
    this.config = { ...this.config, ...updates }
    this.validateConfig()
  }

  getTheme(): WidgetTheme {
    return {
      ...DEFAULT_THEME,
      primaryColor: this.config.themeColor,
    }
  }

  getPositionStyles(): Record<string, string> {
    const baseStyles = {
      position: 'fixed',
      zIndex: '9999',
    }

    switch (this.config.position) {
      case 'bottom-right':
        return { ...baseStyles, bottom: '20px', right: '20px' }
      case 'bottom-left':
        return { ...baseStyles, bottom: '20px', left: '20px' }
      case 'top-right':
        return { ...baseStyles, top: '20px', right: '20px' }
      case 'top-left':
        return { ...baseStyles, top: '20px', left: '20px' }
      default:
        return { ...baseStyles, bottom: '20px', right: '20px' }
    }
  }
}
